import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import { Trans } from "@coworker/locales";
import { Dispatch, SetStateAction } from "react";
import magnifyingGlassIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/MagnifyingGlassIconPath";
import styles from "../swipeable-testbuy-list-view-item.module.css";

interface ChangeWithButtonProps {
  swipeDirection: string;
  setSwipeDirection: Dispatch<SetStateAction<"" | "left" | "right">>;
  onClick: () => void;
}

export const ChangeWithButton = ({
  swipeDirection,
  setSwipeDirection,
  onClick,
}: ChangeWithButtonProps) => {
  return (
    <div
      className={`${styles["button-change-with"]} ${styles["button-change-with-color"]} ${
        swipeDirection === "right"
          ? styles["button-hidden"]
          : styles["button-change-with-visible"]
      }`}
      onClick={() => {
        onClick();
        setSwipeDirection("");
      }}
    >
      <FixaSSRIcon paths={magnifyingGlassIconPath} />
      <span className={styles["button-text"]}>
        <Trans>changeWithString</Trans>
      </span>
    </div>
  );
};
